import { ConsentPolicy } from '@wix/wix-bootstrap-api';
import { Category } from '../../../types/api';
import { TFunction, TranslationKey } from '../../i18n/i18n';
import { AppConfig } from '../../config';

export interface ConfigStoreState {
  currentLanguage: string;
  nativeLanguage: string;
  supportedLanguages: string[];
  baseURL: string;
  domain: string;
  renamedCategories: AppConfig['renamedCategory'];
  customCategoriesTranslations: AppConfig['customCategoriesTranslations'];
  templatePageSessionId: string;
  imagesMediaPlatformDomain: string;
  filesMediaPlatformDomain: string;
  dealerCmsTranslationsUrl: string;
  consentPolicy?: ConsentPolicy;
}

export class ConfigStore {
  constructor(public readonly config: ConfigStoreState) {}

  public getMenuCategoryTitle(category: Category | undefined, t: TFunction): string {
    const translationKey = category ? this.config.customCategoriesTranslations.menu[category.name] : undefined;
    return ConfigStore.translateCategory(translationKey, category, t);
  }

  public getCategoryTitle(category: Category | undefined, t: TFunction): string {
    const translationKey = category ? this.config.customCategoriesTranslations.title[category.name] : undefined;
    return ConfigStore.translateCategory(translationKey, category, t);
  }

  private static translateCategory(
    translationKey: TranslationKey | undefined,
    category: Category | undefined,
    t: TFunction,
  ): string {
    const categoryName = translationKey
      ? t(translationKey, { defaultValue: category?.displayName })
      : category?.displayName;

    return categoryName || t('header.category');
  }

  serialize(): ConfigStoreState {
    return this.config;
  }
}
